// Module
var code = "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"> <path d=\"M12 8.29688L6 14.2969L7.41 15.7069L12 11.1269L16.59 15.7069L18 14.2969L12 8.29688Z\" fill=\"#D0D5DD\"/> </svg> ";
// Exports
module.exports = code;